import React, { useEffect, useState } from "react";

import { ToastError, ToastSuccess } from "src/component/uiElements/toast";
import { LOGOUT } from "src/component/helper/constants";
import {
    SelectDetails as SELECT_DETAILS,
    SelectOwner as SELECT_OWNER_INFO,
    SelectFinancialDetails as SELECT_FINANCIAL_DETAILS,
    SelectedAmenities as SELECTED_AMENITIES,
    SelectMultipleFiles as SELECT_FILES,
} from "src/component/api/PGProperty/PGPropertyAPI";


const UsePgPropertyInformation = (list: any) => {
    const [financialDetails, setFinancialDetails] = useState<any>(null);
    const [OwnersDetails, setOwnersDetails] = useState<any>(null);
    const [propertyDetails, setPropertyDetails] = useState<any>(null);
    const [amenitiesDetails, setAmenitiesDetails] = useState<any>(null);
    const [mediaDetails, setMediaDetails] = useState<any>(null);


    useEffect(() => {
        SelectUploadedImages(list)
        SelectedAmenities(list);
        SelectOwnerInfo(list);
        SelectFinancialDetails(list);
        SelectDetailsInfo(list);
    }, []);


    const SelectUploadedImages = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_FILES(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);
        setMediaDetails(data);

    };

    const SelectedAmenities = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECTED_AMENITIES(request);

        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);

        setAmenitiesDetails(data);
    };

    const SelectDetailsInfo = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_DETAILS(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);

        setPropertyDetails(data);

    };

    const SelectOwnerInfo = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_OWNER_INFO(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);

        setOwnersDetails(data);
    };


    const SelectFinancialDetails = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_FINANCIAL_DETAILS(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);
        setFinancialDetails(data);
    };

    return {
        financialDetails,
        OwnersDetails,
        propertyDetails,
        amenitiesDetails,
        mediaDetails
    };
};

export default UsePgPropertyInformation;
